<template>
  <div>
    <Head :title="`${type.name} Category`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/sku-type/${type.id}/categories`">{{ type.name }} Categories</Link>
      <span class="text-orange-400 font-medium">/</span> Create Category
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-full" label=" Name" />
          <text-input v-model="form.code" :error="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/2" label="Code" />
          <select-input v-model="form.category" :error="form.errors.category" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Category">
            <option :value="null">
              Select the parent
            </option>
            <option
              v-for="(item) in parents"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Create Category</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    type: Object,
    parents: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        code: '',
        category: '',
      }),
      hasParent: false,
    }
  },
  methods: {
    store() {
      this.form.post(`/sku-type/${this.type.id}/categories`)
    },
  },
}
</script>
